<script lang="ts">
  import { NodeViewWrapper, NodeViewContent } from "svelte-tiptap";
  import styles from "./DraggableItem.module.css";
  import cx from "classnames";
  import type { NodeViewProps } from "@tiptap/core";

  export let editor: NodeViewProps["editor"];
</script>

<NodeViewWrapper>
  <div
    class={cx("w-full rounded-md p-2", {
      "border-2 border-neutral-500 bg-neutral-300": editor.isEditable,
    })}
  >
    {#if editor.isEditable}
      <div class={styles.dragHandle} contentEditable="false" draggable="true" data-drag-handle />
    {/if}
    <NodeViewContent class="content-wrapper inline-grid grid-cols-2 gap-4" />
  </div>
</NodeViewWrapper>
